<i18n src="./resources/locales.json"></i18n>
<template>
  <v-combobox
    chips
    deletable-chips
    dense
    multiple
    filled
    background-color="surface"
    hide-details="auto"
    class="email-chips"
    :value="emailsArray"
    :error="error"
    :error-messages="errorMessages"
    :disabled="disabled"
    :delimiters="delimiters"
    @change="onChange"
    @click.native.stop
    @keyup.space.prevent
  >
    <template #append>
      {{ null }}
    </template>
    <template #prepend-inner>
      {{ $t(label) }}
    </template>
    <template #selection="data">
      <v-chip :close="enableClose(data.item)" @click:close="onChipClose(data.item)">{{ data.item }}</v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'EcsEmailsChipField',
  props: {
    emails: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    errorMessages: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    delimiters: {
      type: Array,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    },
    requiredEmails: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    emailsArray() {
      return this.emails.split(';').filter(email => email !== '');
    },
    error() {
      return this.errorMessages.length > 0;
    }
  },
  methods: {
    onChipClose(item) {
      if (this.requiredEmails.includes(item)) {
        return;
      }

      this.onChange(this.emailsArray.filter(email => email !== item));
    },
    enableClose(item) {
      return !this.requiredEmails.includes(item);
    }
  }
};
</script>

<style>
.email-chips .v-chip {
  margin-top: 4px !important;
  height: unset !important;
  margin-bottom: 4px !important;
}
.email-chips .v-input__prepend-inner {
  margin-top: 7px !important;
}
.email-chips .v-text-field__details {
  margin-bottom: 0px !important;
}
.email-chips .v-input__slot,
.email-chips .v-select__slot {
  min-height: 28px !important;
}

.email-chips .v-select__selections {
  min-height: 28px !important;
}
</style>
